module.exports = {"providers":["Google"],"authenticationFlowType":"USER_PASSWORD_AUTH"};